import { regexForName } from "common/constant";
import { getOptionValue, utilityOptionsForUser } from "common/enums";
import * as Yup from "yup";

export const AdminProfileValidationSchema = Yup.object({
  userName: Yup.string().required("User name is required"),
  firstName: Yup.string()
    .matches(regexForName, "Please enter a valid first name")
    .required("First name is required"),
  lastName: Yup.string()
    .matches(regexForName, "Please enter a valid last name")
    .required("Last name is required"),

  email: Yup.string()
    .email("Please enter valid email")
    .required("Email is required"),
});

export const UserProfileValidationSchema = Yup.object({
  firstName: Yup.string()
    .matches(regexForName, "Please enter a valid first name")
    .required("First name is required"),
  middleName: Yup.string().matches(
    regexForName,
    "Please enter a valid middle name"
  ),
  lastName: Yup.string()
    .matches(regexForName, "Please enter a valid last name")
    .required("Last name is required"),
  addressLine1: Yup.string().required("Correspondence Address is required"),
  email: Yup.string()
    .email("Please enter valid email")
    .required("Email is required"),
  mobileNumber: Yup.string()
    .matches(/^\d{10}$/, "Please enter valid mobile number")
    .required("Mobile number is required"),
  pinCode: Yup.string()
    .matches(/^\d{6}$/, "Please enter valid pincode")
    .required("Pincode is required"),
  salutation: Yup.string().required("Salutation is required"),
});

export const initialValuesForProfileDetails = (user) => {
  const {
    firstName,
    lastName,
    middleName,
    salutation,
    addressType,
    addressLine1,
    addressLine2,
    designation,
    profileImage,
    mobileNumber,
    pinCode,
    city,
    email,
  } = user;

  return {
    firstName: firstName ?? "",
    middleName: middleName ?? "",
    lastName: lastName ?? "",
    salutation: salutation ?? "",
    addressType: addressType ?? "",
    email: email ?? "",
    designation: designation ?? "",
    addressLine1: addressLine1 ?? "",
    addressLine2: addressLine2 ?? "",
    city: city ?? "",
    pinCode: pinCode ?? "",
    mobileNumber: mobileNumber ?? "",
    file: "",
    profileImageURL: profileImage ?? "",
  };
};

export const initialValuesForAdminProfileDetails = (user) => {
  const {
    firstName,
    lastName,
    userName,
    profileImage,
    email,
    utilityRoles,
    signatureImage,
  } = user;
  return {
    firstName: firstName ?? "",
    lastName: lastName ?? "",
    email: email ?? "",
    userName: userName ?? "",
    profileImageURL: profileImage ?? "",
    file: "",
    utilityRoles: utilityRoles
      ?.filter(({ utilityId }) =>
        utilityOptionsForUser.map(({ value }) => value).includes(utilityId)
      )
      .map(({ utilityId, roles: currentRoles }) => ({
        utility: [
          getOptionValue("utilityOptions", "Power"),
          getOptionValue("utilityOptions", "DCS"),
        ].includes(utilityId)
          ? utilityId
          : getOptionValue(
              "utilityOptionsForUser",
              "Water, Sewage, Solid Waste"
            ),
        roles: currentRoles,
      })),
    signatureImage: signatureImage ?? "",
  };
};
